import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { FontAwesomeIcon } from './plugins/font-awesome'
import axios from "axios"
import Toast, { TYPE } from 'vue-toastification';
import { useToast } from 'vue-toastification';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'vue-toastification/dist/index.css';
import baseInputField from '@/plugins/baseInputField'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import '@/scss/main.scss'
import { createI18n } from 'vue-i18n'
import en from './locales/en.json'

// Create i18n instance
const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en
  }
})
const toast = useToast();

const app = createApp(App);

app
  .use(router)
  .use(store)
  .use(baseInputField)
  .use(i18n)
  .use(Toast, {
    toastDefaults: {
      [TYPE.SUCCESS]: {
        transition: 'Vue-Toastification__fade',
        maxToasts: 5,
        position: 'bottom-right',
        timeout: 3000,
        icon: true,
        hideProgressBar: true,
        closeOnClick: true
      },
      [TYPE.WARNING]: {
        transition: 'Vue-Toastification__fade',
        maxToasts: 5,
        position: 'bottom-right',
        timeout: 2500,
        icon: true,
        hideProgressBar: true,
        closeOnClick: true
      },
      [TYPE.ERROR]: {
        transition: 'Vue-Toastification__fade',
        maxToasts: 5,
        position: 'bottom-right',
        timeout: 4500,
        icon: true,
        hideProgressBar: true,
        closeOnClick: true
      }
    }
  })
 .component("font-awesome-icon", FontAwesomeIcon);

// app.config.errorHandler = (err, vm, info) => {
//   console.error('An error occurred:', err, info);
//   router.push('/500');
// };

// Suppress the ResizeObserver loop limit exceeded error overlay
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' || e.message === 'ResizeObserver loop limit exceeded') {
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) overlay.style.display = 'none';
    const overlayDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    if (overlayDiv) overlayDiv.style.display = 'none';
  }
});

app.mount('#app');
 
axios.interceptors.request.use(
    function(successfulReq) {
        let user = JSON.parse(localStorage.getItem('user'))
        // console.log ('Axios Interceptor');
        if (user && user.token) {
            successfulReq.headers['Authorization'] = 'Bearer ' + user.token
            return successfulReq;
        } else {
            // Important: reject the request so callers don't hang awaiting a response
            console.error('Auth is missing, please login again');
            try {
              // Avoid navigating if we are already on the login route
              if (router.currentRoute?.value?.path !== '/Login') {
                router.push('/Login');
              }
            } catch (_) { /* no-op */ }
            return Promise.reject(new Error('Missing auth token'));
        }
        
      }, 
      function(error) {
        console.error ('Axios Interceptor ; Here is the error ' , error);
        return Promise.reject(error);
      }
  );

axios.interceptors.response.use(
    response => response,
    async error => {
        if (error?.response?.status === 401) {
            const originalRequest = error.config || {};
            const responseData = error.response?.data;
            const isLoginRequest = originalRequest?.url?.includes('user/login');

            // If this is a retry request or a login request, don't retry
            if (originalRequest._retry || isLoginRequest) {
                localStorage.removeItem('user');
                localStorage.removeItem('token');
                router.push('/Login');
                return Promise.reject(error);
            }

            // Detect explicit permission errors from backend payloads
            const hasExplicitPermissionError = (
              responseData?.status?.code === 403 ||
              responseData?.status?.id === 403 ||
              responseData?.code === 403 ||
              responseData?.error === 'permission_denied'
            );

            // Classify clearly write/privileged attempts
            const isWriteAttempt = (
              originalRequest?.method === 'put' ||
              originalRequest?.method === 'post' ||
              originalRequest?.url?.includes('gateway/add_groups') ||
              originalRequest?.url?.includes('gateways/clean')
            );

            // Read-only users hitting user directory endpoints should not be logged out
            const storedUser = JSON.parse(localStorage.getItem('user'));
            const userType = storedUser?.user?.Info?.user_type;
            const readOnlyRoles = ['2', '5']; // customer / production
            const isReadOnlyUser = readOnlyRoles.includes(String(userType));
            const isUserDirectoryRequest = (
              originalRequest?.method === 'get' && (
                originalRequest?.url?.includes('/users') ||
                originalRequest?.url?.includes('/user/info')
              )
            );

            if (
              hasExplicitPermissionError ||
              isWriteAttempt ||
              (isReadOnlyUser && isUserDirectoryRequest)
            ) {
                toast.error('You do not have permission to perform this action 😔');
                return Promise.reject(error);
            }

            // For other 401s, assume token is expired and require re-login
            try {
                originalRequest._retry = true;
                throw new Error('Token refresh failed');
            } catch (refreshError) {
              console.error('Session expired, please log in again');
              localStorage.removeItem('user');
              localStorage.removeItem('token');
              router.push('/Login');
              return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);
